// BE CAREFUL!!!! TO HAVE ACCESS tO THE BACKEND YOU HAVE TO BE CONNECTED TO EESTEC VPN

let config = {
    backend: "costeltestdb.eestec.ro",
    isDev: false,
    port: 8080,
    costelgpt: "https://api-awh76sh62a-uc.a.run.app",
    handrulesLobbyId: 69
};

if (process.env.REACT_APP_NODE_ENV === "production") {
    config = {
        backend: "costeldb.eestec.ro",
        isDev: false,
        port: 8080,
        handrulesLobbyId: 69,
        costelgpt: "https://api-awh76sh62a-uc.a.run.app",
    };
}

if(process.env.REACT_APP_NODE_ENV === "local_be") {
    config = {
        backend: "localhost",
        isDev: true,
        port: 8080,
        handrulesLobbyId: 69,
        costelgpt: "https://api-awh76sh62a-uc.a.run.app",
    };
}

export default config;